<template>
  <div class="content">
    <div class="card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>收益</el-breadcrumb-item>
        <el-breadcrumb-item>收益分成</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="title-content">
        <div class="left">
          <h2 class="title">收益分成</h2>
        </div>
        <div class="right">
          <el-button
            type="primary"
            size="mini"
            @click="openProfitCreate"
          >创建</el-button>
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top:24px;"
    >
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
        label-width="80px"
      >

        <el-form-item
          label="商品名称"
          prop="name"
        >
          <el-input
            v-model="query.product_name"
            placeholder="输入商品名称"
            @input="fetchList(true)"
            style="width:300px;"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品类型"
          prop="ref_type"
        >
          <el-select
            v-model="query.product_type"
            clearable
            placeholder="请选择"
            style="width: 300px"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.refTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="card"
      style="margin-top:24px;"
    >
      <div class="table-header">
        <h3 class="title">收益列表</h3>
        <div></div>
      </div>
      <div class="table-wrap">
        <el-table
          :data="results"
          border
          style="width: 100%"
        >

          <el-table-column
            prop="id"
            width="80"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="product_type"
            width="100"
            label="商品类型"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formateProductTypes(scope.row.product_type) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="id"
            label="商品图"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="height: 50px"
                :src="scope.row.product_picture_url"
                fit="fill"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.product_name }}
            </template>
          </el-table-column>
          <!--         <el-table-column
            prop="product_type"
            width="100"
            label="商品状态"
            align="center"
            show-overflow-tooltip
          >

          </el-table-column> -->
          <el-table-column
            label="售价"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.product_price > 0">{{
                scope.row.product_price + "元"
              }}</span>
              <span v-else>免费</span>
            </template>
          </el-table-column>
          <!--   <el-table-column
            prop="charge_amount"
            label="收益分成"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.charge_amount}}元
            </template>
          </el-table-column> -->
          <el-table-column
            prop="product_name"
            label="收益分成"
            width="150px"
            align="center"
            show-overflow-  
          >
            <template slot-scope="scope">
              <span v-if="scope.row.charge_rate&&scope.row.charge_amount">{{scope.row.charge_amount}}元</span>
              <span v-else-if="scope.row.charge_rate">{{scope.row.charge_rate*100}}%</span>
              <span v-else-if="scope.row.charge_amount">{{scope.row.charge_amount}}元</span>
              <span v-else>{{scope.row.charge_amount}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="合作状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status==1"
                size="small"
                effect="dark"
              >合作中</el-tag>
              <el-tag
                type="warning"
                v-if="scope.row.status==2"
                size="small"
                effect="dark"
              >已到期</el-tag>
              <el-tag
                type="danger"
                v-if="scope.row.status==3"
                size="small"
                effect="dark"
              >已清退</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160px"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openEdit(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <ProfitCreate
      :visible="ProfitCreateDialog"
      :content="ProfitCreateContent"
      @close="ProfitCreateDialog=false"
      @submit="fetchList()"
    />
    <ProfitEdit
      :visible="ProfitEditDialog"
      :content="ProfitEditContent"
      @close="ProfitEditDialog=false"
      @submit="fetchList()"
    />
  </div>
</template>

<script>



import { authorChargelist, authorChargeDelete } from "@/api/seniorprofit";
import ProfitCreate from "@/components/dialog/senior/ProfitCreate.vue";
import ProfitEdit from "@/components/dialog/senior/ProfitEdit.vue";
export default {
  components: {
    ProfitCreate,
    ProfitEdit
  },
  data() {
    return {
      results: [],
      pageTotal: 10,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      ProfitCreateDialog: false,
      ProfitCreateContent: {},
      ProfitEditDialog: false,
      ProfitEditContent: {},
      filter: {
        refTypes: [
          { label: "课程", value: "1" },
          { label: "题库", value: "2" },
          { label: "专栏", value: "3" },
          { label: "资料", value: "4" },
          { label: "文章", value: "5" },
          { label: "学长", value: "6" },
          { label: "联报", value: "7" },
        ],
      },
    };
  },
  created() {
    this.fetchList()
  },

  computed: {

  },
  methods: {
    // 文章列表请求
    fetchList() {
      authorChargelist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ];
      }
    },
    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        authorChargeDelete({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    formateProductTypes(type) {
      const types = {
        0: "无",
        1: "课程",
        2: "题库",
        3: "专栏",
        4: "资料",
        5: "文章",
        6: "学长",
        7: "联报",
      }
      return types[type]
    },
    openProfitCreate() {
      this.ProfitCreateDialog = true
    },
    openEdit(row) {
      this.ProfitEditContent = Object.assign({}, row)
      this.ProfitEditDialog = true
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  padding: 20px;
  .title-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
  }
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 32px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
  }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }

  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .menu-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
}
.el-link {
  margin: 0px 5px;
}
</style>
